// src/components/ClientContracts.tsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ClientContracts: React.FC = () => {
    const [contracts, setContracts] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetchContracts();
    }, []);

    const fetchContracts = async () => {
        setIsLoading(true);
        setError('');
        try {
            const token = localStorage.getItem('clientToken');
            console.log('Fetching contracts with clientToken:', token);
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/ClientContracts`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setContracts(response.data);
        } catch (error: any) {
            console.error('Error fetching contracts:', error);
            setError('Failed to load contracts.');
            if (error.response?.status === 401) {
                console.log('Unauthorized - redirecting to client login');
                localStorage.removeItem('clientToken');
                window.dispatchEvent(new Event('clientAuthChange'));
                navigate('/client/login');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleViewSign = (contractId: number) => {
        console.log('Navigating to contract:', contractId, 'with clientToken:', localStorage.getItem('clientToken'));
        navigate(`/client/contract/${contractId}`);
    };

    return (
        <div className="container mt-5">
            <h2 className="mb-4 text-center">Your Contracts</h2>
            {error && <div className="alert alert-danger">{error}</div>}
            {isLoading && <div className="alert alert-info">Loading...</div>}
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow-sm">
                        <div className="card-header bg-primary text-white">
                            <h4 className="mb-0">Contracts ({contracts.length})</h4>
                        </div>
                        <div className="card-body">
                            {contracts.length === 0 && !isLoading && !error ? (
                                <p className="text-muted text-center">No contracts assigned yet.</p>
                            ) : (
                                <ul className="list-group list-group-flush">
                                    {contracts.map((contract) => (
                                        <li key={contract.id} className="list-group-item d-flex justify-content-between align-items-center">
                                            <div>
                                                {contract.name || `Contract ${contract.id}`}
                                                <small className="d-block text-muted">Status: {contract.status}</small>
                                                <small className="d-block text-muted">Signed: {contract.hasSignature ? 'Yes' : 'No'}</small>
                                            </div>
                                            <button
                                                onClick={() => handleViewSign(contract.id)}
                                                className="btn btn-outline-primary btn-sm"
                                            >
                                                View/Sign
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientContracts;